module.exports = __webpack_public_path__ + "img/product_logo_mobile.2da62321.png";